import CopyTooltip from './copyTooltip';

export default CopyTooltip;
